<!-- =========================================================================================
    ----------------------------------------------------------------------------------------
         Author: Jose Martin de la Cruz Vicencio
    Author URL: benko
========================================================================================== -->
<template>

    <div id="data-list-list-view" class="data-list-container">
        <!-- <vs-popup style="" class=""  title="Folio Ceneval:" :active.sync="popupActiveCeneval">
                <p>Folio
                    <vs-input class="" style="width: 100%" placeholder="" v-model="folio_ceneval" />
                </p>
            <p style="margin: 10px;">
                <vs-button  class="float-right"  @click="guardar_folio_ceneval()">Guardar</vs-button>
            </p>
        </vs-popup> -->
        <!-- <vs-popup style="" class="holamundo"  title="Datos:" :active.sync="popupActiveDatos">
            <p>
                <vs-table stripe :data="datos_candidato">

                    <template slot="thead">
                        <vs-th>Dato</vs-th>
                        <vs-th>Valor</vs-th>
                    </template>
                    <template>
                        <vs-tr>
                            <vs-td>
                                ID
                            </vs-td>
                            <vs-td>
                                {{idc}}
                            </vs-td>
                        </vs-tr>
                        <vs-tr>
                            <vs-td>
                                CURP
                            </vs-td>
                            <vs-td>
                                {{datos_candidato.curp}}
                            </vs-td>
                        </vs-tr>
                        <vs-tr>
                            <vs-td>
                                Correo
                            </vs-td>
                            <vs-td>
                                {{datos_candidato.correo}}
                            </vs-td>
                        </vs-tr>

                        <vs-tr>
                            <vs-td>
                                Nombres
                            </vs-td>
                            <vs-td>
                                {{datos_candidato.nombres}}
                            </vs-td>
                        </vs-tr>
                        <vs-tr>
                            <vs-td>
                                Apellido Paterno
                            </vs-td>
                            <vs-td>
                                {{datos_candidato.apaterno}}
                            </vs-td>
                        </vs-tr>
                        <vs-tr>
                            <vs-td>
                                Apellido Materno
                            </vs-td>
                            <vs-td>
                                {{datos_candidato.amaterno}}
                            </vs-td>
                        </vs-tr>


                    </template>
                </vs-table>

            </p>
                <br/>
                <br/>
            <p>
                En caso de rechazar los datos escriba la razon:
                <vs-input class="" style="width: 100%" placeholder="" v-model="rechazo_datos" />
            </p>
            <p style="margin: 10px;">
                <vs-button  class="float-right"  @click="validar_datos(idc)">Aprobar</vs-button>
                <vs-button  class="float-right" style="margin-right: 10px;" color="warning"  @click="rechazar_datos(idc, rechazo_datos)">Rechazar</vs-button>
            </p>
        </vs-popup> -->
        <!-- <vs-popup style="" class="holamundo"  title="Documentos:" :active.sync="popupActiveDocumentos">
            <p>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.foto)">foto</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.certificado)">certificado</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.acta)">acta</vs-button>


            </p><br/><br/>

            <p>
                En caso de rechazar los documentos escriba la razon:
                <vs-input class="" style="width: 100%" placeholder="" v-model="rechazo_documentos" />
            </p>
            <p style="margin: 10px;">
                <vs-button style="margin: 5px"  class="float-right"  @click="validar_documentos(idc)">Aprobar</vs-button>
                <vs-button style="margin: 5px" color="warning"  class="float-right"  @click="rechazar_documentos(idc, rechazo_documentos)">Rechazar</vs-button>
            </p>
        </vs-popup> -->

        <!-- <vs-popup style="" class="holamundo"  title="Pago:" :active.sync="popupActivePago">

            <p style="margin: 10px; text-align: center" >
                <vs-button   class=""  @click="validar_pago(idc)">validar</vs-button>

            </p>
        </vs-popup> -->

        <!-- <vs-popup style="" class="holamundo"  title="Documentos:" :active.sync="popupActiveDocumentos2">
            <p>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.acta2)">Acta de nacimiento</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.curp2)">CURP</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.comprobante)">Comprobante de domicilio</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.certificado2)">Certificado</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.pago)">Registro de pago</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.ceneval)">Pase ceneval</vs-button>
            </p><br/><br/>

            <p>
                Capture el folio ceneval:
                <vs-input class="" style="width: 100%" placeholder="" v-model="folio_ceneval2" />
            </p>

            <p>
                En caso de rechazar los documentos escriba la razon:
                <vs-input class="" style="width: 100%" placeholder="" v-model="rechazo_documentos2" />
            </p>
            <p style="margin: 10px;">
                <vs-button  style="margin: 5px" class="float-right"  @click="validar_documentos2(idc)">Aprobar</vs-button>
                <vs-button  style="margin: 5px" class="float-right" color="warning" @click="rechazar_documentos2(idc, rechazo_documentos2)">Rechazar</vs-button>
            </p>
        </vs-popup> -->

<vx-card title=""> 

     <!-- <div class="col-2"> Fecha Examen   <div>
                   <v-select label="fecha" @change="onChangeFechas()" v-model="fecha_admision" :options="fechas_examen">
                    </v-select>       
                </div>
            </div>
 <br> -->

<div class="flex mb-4"  >

<div class="container text-center">
  <div class="row">
    <div class="col-4">
      
 <div class="alert alert-info" role="alert" >

            <p class="fs-5">
                     Año y periodo a matricular:    
                   <b> {{ultima_matricula_generada}}</b>
                    </p>     
                   
</div>                     

    </div>
    <div class="col-4">
          <center>
       <div class="w-2/3 bg-grid-color h-12 flex">
             
                     <span class="sm:flex hidden m-auto">
                     
                        <a target="_self" style="float:right;">
                                 <p id="btn_rubrica2">
                            <vs-button :disabled="selectedCandidatos.length === 0"  @click="enviarCorreo()">Generar Matriculas Nuevas</vs-button>
                              </p>
                         </a> 
                    </span>
           
                </div>    
                 </center>
        

    </div>
     <div class="col-4">
        
        <!--  v-show="cantidad_aspirantes_fecha>1"  -->
      <div class="alert alert-warning" role="alert">
                  <center>
                   <p class="fs-6" >
                  Cambiar año y periodo => <input class="form-check-input" title="Seleccionar solo si estas seguro del cambio" type="checkbox" role="switch" v-model="EditarCampo" id="flexSwitchCheckNoCertificado"  />
                  <vs-input   :disabled="EditarCampo == false"   v-model="ultima_matricula_generada" />      
                </p>      
                </center>       
                
     </div>


    </div>
  </div>

</div>


     <!-- <vue-excel-xlsx id="btn_excel" style="margin: 2px 2px; display:none;" class="vs-component  vs-button vs-button-success vs-button-filled float-right"
                    :data="aspirantes_fecha"
                    :columns="columns"
                    :filename= "'RubricaDeEvaluacion'"
                    :sheetname="'Lista'" >
                    Descargar Archivo en Excel (XLS)
            </vue-excel-xlsx> -->        
            
</div>

</vx-card>
            

        <vs-table multiple v-model="selectedCandidatos" @selected="handleSelected"  ref="table" pagination :max-items="800" stripe search :data="lista_candidatos_para_matricular">
                <!-- <vs-table multiple v-model="selected" @selected="handleSelected" :data="users">  -->
                    <!-- <vs-table search pagination :maxItems="30" stripe :data="grupos"> -->

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

             </div>

            <template slot="thead">

                <vs-th>Número</vs-th>
                <vs-th sort-key="id">Ficha</vs-th>
                <vs-th>Folio CENEVAL</vs-th>
                <vs-th>Nombre completo</vs-th>
                <!-- <vs-th>Carrera</vs-th> -->
                <vs-th>Correo</vs-th>
                <vs-th>Curp</vs-th>
                <!-- <vs-th>Observaciones</vs-th> -->
                
                <!-- <vs-th>Detalles</vs-th> -->
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    
                   <vs-td :data="data[indextr].id">
                       {{ indextr + 1 }}
                    </vs-td>
                    <vs-td :data="data[indextr].id">
                        {{ tr.id }}
                    </vs-td>

                    <vs-td :data="data[indextr].folioCeneval2">
                       {{ tr.folioCeneval2 }}
                    </vs-td>
                    <vs-td :data="data[indextr].nombres">
                        {{ tr.nombres }}  {{ tr.aPaternoCandidato }}  {{ tr.aMaternoCandidato }}
                    </vs-td>
                   <!-- <vs-td :data="data[indextr].carrera">
                      {{tr.carrera}}
                  </vs-td> -->
                    <vs-td :data="data[indextr].correo">
                        {{ tr.correo }}
                    </vs-td>
                    <vs-td :data="data[indextr].curp">
                   {{ tr.curp }}
                  </vs-td>
                    <!-- <vs-td :data="data[indextr].carrera2">
                       observaciones
                    </vs-td> -->
                    <!-- <vs-td :data="data[indextr].carrera2">
                       
                    </vs-td> -->

                    <!-- <vs-td v-if="tr.action == 1">

                        <vs-button @click="cambiar_estatus(tr.statusId, tr.idc)" size="small" color="primary" type="gradient">
                        {{tr.statusDescripcion}}</vs-button>

                    </vs-td>
                    <vs-td v-else>

                        <vs-button size="small" color="primary" type="border">{{tr.statusDescripcion}}</vs-button>

                    </vs-td> -->

                    <!-- <vs-td :data="tr.id">
                        <vs-button size="small" @click="detalles_candidato(tr.idc)" color="success" type="gradient">Ver Ficha</vs-button>
                    </vs-td> -->


                </vs-tr>
                </tbody>
            </template>
        </vs-table>

    <!-- previo select      -->
          <br> 
    <!-- <pre>{{ selectedCandidatos }}</pre> -->

    </div>

</template>

<script>
    import vSelect from 'vue-select'

    export default {
        data() {
            return {
                idc: 0,
                // status_actual: 0,
                  id_rol: this.getKey('id_rol'), 
                lista_candidatos_para_matricular: [],
                
                ultima_matricula_generada:'',
                // selected: [],
                 selectedCandidatos: [],
                // users: [],
                EditarCampo:'',
                itemsPerPage: 500,
                isMounted: false,
                // addNewDataSidebar: false,

                // popupActiveCeneval:false,
                // popupActiveDatos:false,
                // popupActiveDocumentos:false,
                // popupActivePago:false,
                // popupActiveDocumentos2:false,

                // folio_ceneval: '',
                // rechazo_datos: '',
                // rechazo_documentos: '',
                // rechazo_documentos2: '',
                // datos_candidato: '[{}]',
                // fechas_examen:[],
                // fecha_admision:{},
                // columns : [
                //     {
                //         label: "Ficha",
                //         field: "ficha",
                //     },
                //     {
                //         label: "Folio CENEVAL",
                //         field: "folioCeneval2",
                //         // dataFormat: this.priceFormat
                //     },
                //     {
                //         label: "Nombre completo",
                //         field: "nombreCompleto",
                //     },
                //     {
                //         label: "Carrera",
                //         field: "carrera",
                //     },
                //     {
                //         label: "2da Opción",
                //         field: "carrera2",
                //     },
                //      {
                //         label: "Puntaje CENEVAL",
                //         field: "puntajeCeneval",
                //     }                           

                // ],
                // aceptados:{}
               

            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx;
                }
                return 0;
            },
        },
        components: {
            'v-select': vSelect
                // SelectingValuesSingleMultipleSelection
        },
        created() {
             if(this.id_rol == 1 || this.id_rol == 5){
            this.getAspirantes();
            this.ultima_matricula();
       }

        },
        mounted() {
            this.isMounted = true;
            
  
        },
        watch: {
            // whenever question changes, this function will run
            // status_actual: function(){
            
            //     this.muestra_modal();
            // },
        },

        methods: {


           enviarCorreo(){
               this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Generacion de matriculas y Envio de Correos`,
                    text: '¿Está seguro de que deseas Generar las matriculas y  enviar correos?',
                    accept: this.realizarEnvioCorreos
                 });
           },
            realizarEnvioCorreos(){

                // alert("enviando..");
                // console.log(this.ultima_matricula_generada);
                // console.log(this.selectedCandidatos);
  
                this.$http.post("generar_matriculas_enviar_correo_nuevo_ingreso",{agnoyperiodo:this.ultima_matricula_generada,array_candidatos:this.selectedCandidatos}).then(
                        response => {
                                   
                             if(response.data.array_aceptados==="OK"){ 
                                    this.$vs.notify({ time: 2700,color: 'success', title: 'Generacion de Matriculas y Envio de correos Exitoso', text: 'Se han enviado correctamente' });
                                    
                                     this.selectedCandidatos=[]; 
                                 
                                }else{
                                    this.$vs.notify({
                                        time: 2700,
                                        title: 'Error',
                                        text: response.data.array_aceptados,
                                        iconPack: 'feather',
                                        icon: 'icon-alert-circle',
                                        color: 'danger'
                                    });
                                }                                                           
                                                                
                         },
                        error => {
                            this.steperror(error);
                        }
                   );


            },

           handleSelected(tr){
                     
                    //  pluyin de notificaciones de vie una ventana emergente con aviso emegrgente por aaccion de clic
                     this.$vs.notify({
                          title: `seleccionado ${tr.id}`,
                          text: `NombreCompleto: ${tr.nombres}`
                                    })
                                    // console.log(this.selectedCandidatos);
                                    // en este console se muestra el objeto de select de datos en un objeto de array listo par mandar por pos a cdn
                                    // ACUERDATE DE LIMPIAR EL SELECTCANDIDATOS AL ENVIAR LOS CORREOS
               },
           
   
            //  onChangeFechas:function () {
            //          this.getAspirantes();  
            //          this.selectedCandidatos=[];                          
            // },

            // ver_archivo(id){
            //     window.open('https://cdn.upbicentenario.edu.mx/candidatos_1_2021/' + id);
            // },
            // cambiar_estatus(status, idc){
            //     this.status_actual = status
            //     this.idc = idc
            // },
            // guardar_folio_ceneval(){

            //     this.$http.get("guardar_folio_ceneval/" + this.idc + "/" + this.folio_ceneval).then(
            //         response => {
            //             this.popupActiveCeneval = false
                    
            //         },
            //         error => {
            //             this.StepError(error);
            //         }
            //     );

            // },
            // get_datos_candidato(){
            //     this.$http.get("get_datos_candidato/" + this.idc).then(
            //         response => {
            //              this.datos_candidato = response.data.datos[0];
                      
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );
            // },
            // muestra_modal(){
           
            //    if(this.status_actual == 3){
            //        this.get_datos_candidato()
            //        this.popupActiveDatos = true;
            //        this.status_actual = false;
                     
            //     }
            //     if(this.status_actual == 6){
            //         this.get_datos_candidato()
            //         this.popupActiveDocumentos = true;
            //         this.status_actual = false;
                       
            //     }
            //     if(this.status_actual == 9){
            //         this.get_datos_candidato()
            //         this.popupActivePago = true;
            //           this.status_actual = false;
                     
            //     }
            //     if(this.status_actual == 10){
            //         this.get_datos_candidato()
            //         this.popupActiveCeneval = true;
            //         this.status_actual = false;
                    
            //     }
            //     if(this.status_actual == 12){
            //         this.get_datos_candidato()
            //         this.popupActiveDocumentos2 = true;
            //         this.status_actual = false;
                    
            //     }


            // },
            // detalles_candidato(id){
            //     window.open('https://cdn.upbicentenario.edu.mx/api/pdf_ficha/' + id)
            // },
            getAspirantes () {
            //    var idfechaSelect='';
                //    idfechaSelect=this.fecha_admision.id;
                // console.log(idfechaSelect);
                this.$http.post("lista_candidatos_para_matricular").then(
                        response => {
                        this.lista_candidatos_para_matricular = response.data.lista_candidatos_para_matricular;
                        // console.log(this.lista_candidatos_para_matricular);
                                //   document.getElementById("btn_rubrica").style.display = "block";
                                //     document.getElementById("btn_rubrica2").style.display = "block";
                                //     document.getElementById("btn_excel").style.display = "block";     
                    },
                    error => {
                        this.steperror(error);
                    }
                );
            },

            // getFechasExamen() {
            //     this.$http.get("fechasAdmisionTodas").then(
            //         response => {     
            //             this.fechas_examen = response.data.fechasAdmisionTodas;
            //               },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );
            // },


            // validar_datos(id){

            //     this.$http.get("validardatosadmision/" + id).then(
            //         response => {
            //             this.popupActiveDatos = false
                     
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },
            // rechazar_datos(id, razon){

            //     this.$http.get("rechazardatosadmision/" + id + '/' + razon).then(
            //         response => {
            //             this.popupActiveDatos = false
                       
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },
            // validar_documentos(id){

            //     this.$http.get("validardocumentosadmision/" + id ).then(
            //         response => {
            //             this.popupActiveDocumentos = false
                    
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },
            // rechazar_documentos(id, razon){

            //     this.$http.get("rechazardocumentosadmision/" + id + "/" + razon).then(
            //         response => {
            //             this.popupActiveDocumentos = false
            //             // this.getAspirantes();
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },

            ultima_matricula(){

                this.$http.get("ultima_matricula_generada").then(
                    response => {
                        this.ultima_matricula_generada = response.data.ultima_matricula_generada;
                        // this.getAspirantes();
                    },
                    error => {
                        this.steperror(error);
                    }
                );

            },
            // rechazar_documentos2(id, razon){

            //     this.$http.get("rechazardocumentosadmisionfinales/" + id + "/" + razon).then(
            //         response => {
            //             this.popupActiveDocumentos2 = false
            //             // this.getAspirantes();
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },

            // validar_pago(id){

            //     this.$http.get("validarpagoadmision/" + id).then(
            //         response => {
            //             this.popupActivePago = false
            //             // this.getAspirantes();
            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );


            // },
    //   ver_rubrica(){
    //     var idfechaSelect='';
    //        idfechaSelect=this.fecha_admision.id; 
    //       window.open('https://cdn.upbicentenario.edu.mx/api/pdf_rubrica/' + idfechaSelect);
    //   },

    //   aceptados(){
    //     alert("Enviar correo de candidatos, aceptados");
    //   },



    },
}
</script>


<style lang="scss">
    p{

            text-transform: uppercase;
        font-size: 12px !important;

    }
    #data-list-list-view {
        .vs-con-table {

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 12px;
                margin-right: 12px;
                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search{
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 1rem;
                        font-size: 12px;

                        &+i {
                            left: 1rem;
                        }

                        &:focus+i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr{
                    box-shadow: 0 4px 5px 0 rgba(0,0,0,.05);
                    td{
                        padding: 5px;
                        &:first-child{
                            border-top-left-radius: 5px;
                            border-bottom-left-radius: 5px;
                        }
                        &:last-child{
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }
                    td.td-check{
                        padding: 5px !important;
                    }
                }
            }

            .vs-table--thead{
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text{
                        text-transform: uppercase;
                        font-weight: 600;

                    }
                }
                th.td-check{
                    padding: 0 15px !important;
                }
                tr{
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>


